export default __webpack_public_path__ + "static/media/cooker1.484e7186.jpg";